import axios from "axios";
import { Authentication } from "./resources";
import {
  setAccessToken,
  getAccessToken,
  getRefreshToken,
  removeAccessToken,
  removeRefreshToken,
  reverse,
} from "./constants";
import {
  NotAuthenticatedError,
  BadRequestError,
  NotFoundError,
} from "./errors";

import {
  ContainerAssignments,
  Warehouses,
  ItemIdAssignments,
  DefaultAssignments,
  Readers,
} from "../warehouse/client/resources";
import {
  Gtins,
  GtinSeriesResource,
  GraisResource,
  GraiSeriesResource,
} from "../serialization/client/resources";
import { Devices } from "../device/client/resources";

export default class ApiClient {
  constructor() {
    const instance = axios.create();
    instance.interceptors.request.use(_requestInterceptor, null);
    instance.interceptors.response.use(null, responseRejectedInterceptor);

    this.authentication = new Authentication(instance);

    this.warehouses = new Warehouses(instance);
    this.containerAssignments = new ContainerAssignments(instance);
    this.itemIdAssignments = new ItemIdAssignments(instance);
    this.defaultAssignments = new DefaultAssignments(instance);
    this.readers = new Readers(instance);

    this.gtins = new Gtins(instance);
    this.gtinSeries = new GtinSeriesResource(instance);
    this.grais = new GraisResource(instance);
    this.graiSeries = new GraiSeriesResource(instance);

    this.devices = new Devices();
  }
}

function _requestInterceptor(config) {
  const accessToken = getAccessToken();

  if (!accessToken) {
    return config;
  }

  // Authenticate request using stored access token
  config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
}

export async function responseRejectedInterceptor(error) {
  if (error.request) {
    if (error.response.status === 401) {
      removeAccessToken();

      const refreshToken = getRefreshToken();
      if (refreshToken) {
        try {
          const response = await axios.post(reverse("refreshToken"), {
            refresh: refreshToken,
          });
          const accessToken = response.data.access;

          setAccessToken(accessToken);

          return axios(_requestInterceptor(error.config));
        } catch (error) {
          if (error.request && error.response.status === 401) {
            removeRefreshToken();
            return Promise.reject(new NotAuthenticatedError());
          }
        }
      }

      return Promise.reject(new NotAuthenticatedError());
    }
    if (error.response.status === 400) {
      throw new BadRequestError(error.response.data);
    }

    if (error.response.status === 404) {
      throw new NotFoundError();
    }
  }

  return Promise.reject(error);
}
